<template>
  <div class="order-detail" v-loading="loading">
    <div class="order-detail-left">
      <main>
        <div class="header">
          <div class="title">商品信息</div>
          <div class="num">x{{ goods.skuNum }}</div>
        </div>
        <div class="order-container">
          <div class="order">
            <div class="goods" v-if="goods">
              <div class="order-message">
                <div class="flex" style="cursor: pointer">
                  <img
                    :src="goods.skuExtInfo.skuImage ? goods.skuExtInfo.skuImage : goods.skuExtInfo.mainImage"
                    alt=""
                    class="img-con"
                  />
                  <div class="goods-inf">
                    <p class="title">
                      <span class="activityTag">{{ goods.activityTag }}</span>
                      <!-- <img
                      class="prizeTab"
                      style="width:70px;height: 56px;marginRight:14px;"
                      src="@/assets/images/activity/groupTag.png"
                    /> -->
                      <span class="goods-name">{{ goods.itemName }}</span>
                    </p>
                    <div class="goods-sku">
                      <span style="marginRight:10px" v-for="(item, index) in saleAttributes" :key="index">
                        {{ item.attrVal }}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="payment-amount">
                  <div class="left">支付金额</div>
                  <div class="right">
                    {{
                      goods.skuExtInfo.activityPrice - favorablePrice > 0
                        ? goods.skuExtInfo.activityPrice - favorablePrice
                        : 0 | currency('￥', 2)
                    }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <!-- 经销商信息
    <section v-if="dealer && dealer !== {}">
      <header>提车经销商:</header>
      <ul class="distributor inf-box">
        <li>
          经销商:<span class="color-666 margin-left5">{{ dealer.dealerName }}</span>
        </li>
        <li>
          电&emsp;话:<span class="color-666 margin-left5">{{ dealer.salesPhone }}</span>
        </li>
        <li>
          地&emsp;址:<span class="color-666 margin-left5">{{ dealer.detail }}</span>
        </li>
      </ul>
    </section> -->
      <!-- <div class="price-box">
      <div class="box-title">恭喜您已组团成功，完成购车后获得<span class="coupon">500元现金红包</span></div>
      <div class="bottom">
        <div class="qrCode-wrap">
          <p class="text">微信扫码查看邀约详情</p>
        </div>
        <ul class="price-inf">
          <li class="flex-center">
            <div class="left">商品件数<i class="empty"></i></div>
            <span class="color-pink">{{ quantity }}</span>
          </li>
          <li class="flex-center">
            <div class="left">商品合计<i class="empty"></i></div>
            <span class="color-pink">{{ orderInfo.originFee | currency('￥', 2) }}</span>
          </li>
          <li class="flex-center">
            <div class="left">活动优惠<i class="empty"></i></div>
            <span class="color-pink">{{ activityDiscounts | currency('￥', 2) }}</span>
          </li>
          <li class="flex-center">
            <div class="left">优惠券抵扣<i class="empty"></i></div>
            <span class="color-pink">{{ couponDiscounts | currency('￥', 2) }}</span>
          </li>
          <li class="flex-center">
            <div class="left">运费<i class="empty"></i></div>
            <span class="color-pink">{{ orderInfo.shipFee | currency('￥', 2) }}</span>
          </li>
          <li class="flex-center">
            <div class="left">{{ type === 0 || type === 4 ? '应' : '实' }}付总额<i class="empty"></i></div>
            <span class="color-pink total-pay">{{ orderInfo.fee | currency('￥', 2) }}</span>
          </li>
        </ul>
      </div>
    </div> -->
      <div class="activity-schedule">
        <div class="header">
          活动进度
        </div>
        <div class="activity-message">
          <div style="marginBottom:13px">
            <span class="activity-status">
              拼团进行中
            </span>
            <span class="activity-num"> {{ joinNum }}人已成团 </span>
          </div>
          <div class="activity-progress">
            <!-- 进度条 -->
            <div class="progress-bar">
              <div class="progress-top">
                <span class="progress-text" v-if="joinNum < 1">未开始</span>
                <span class="progress-text-begin" v-else>已优惠</span>
                <span class="progress-text" v-for="(item, index) in progressList" :key="index">{{
                  item.favorablePrice | currency('￥', 2)
                }}</span>
                <!-- <span class="progress-text">¥2999</span> -->
              </div>
              <div class="progress-center">
                <el-progress
                  :color="customColorMethod"
                  :show-text="false"
                  :stroke-width="12"
                  :percentage="groupRate(progressList)"
                  :show-pivot="false"
                  :stroke-linecap="'square'"
                ></el-progress>
                <div class="white-line" v-if="progressList && progressList.length > 1"></div>
              </div>
              <div class="progress-bottom">
                <span class="progress-text">还差</span>
                <span class="progress-text" v-for="(item, index) in progressList" :key="index"
                  >{{ 0 > Number(item.participantNum - joinNum) ? 0 : item.participantNum - joinNum }}人</span
                >
              </div>
              <!-- <span class="progress-text">400人</span></div -->
            </div>
            <!-- <div class="progress-item" v-for="(item, index) in progressList" :key="index">
            <div :class="index === 0 ? 'first' : 'others'">
              <span v-if="index === 0" class="tips">已优惠</span>
              <span class="price">{{ item.favorablePrice | currency('￥', 2) }}</span>
            </div>
            <el-progress
              :stroke-width="16"
              :show-text="false"
              class="progress"
              :percentage="percentage(item)"
            ></el-progress>
            <div :class="index === 0 ? 'first' : 'others'">
              <span class="short" v-if="index === 0">还差</span>
              <span class="num">{{ needNum(item) }}人</span>
            </div>
          </div> -->
          </div>
        </div>
      </div>
      <div class="button" v-if="status === 0 || status === 1">
        <div class="to-pay" @click="toPay(status)">
          {{ status === 0 ? '去支付' : '查看订单' }}
        </div>
      </div>
    </div>
    <div class="order-detail-right" v-if="smallGroupTitle">
      <div class="price-box" v-if="showQRcode">
        <div class="box-title">
          <div class="left">参团成功</div>
          <div class="right" v-if="smallGroupNum > 0">邀约{{ smallGroupNum }}人即享{{ smallGroupTitle }}</div>
          <div class="right" v-else>
            恭喜您已组团成功，完成购买后
            <div>
              获得<span class="smallGroupTitle">{{ smallGroupTitle }}</span>
            </div>
          </div>
        </div>
        <div class="bottom">
          <div class="qrCode-wrap">
            <div ref="qrCodeDiv" id="qrCode"></div>
            <p class="text">微信扫码查看邀约详情</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { dateFormate } from '@/lib/utils'
import iconToPay from '@/assets/icons/order/icon-toPay.png'
import iconClose from '@/assets/icons/order/icon-close.png'
import iconFinish from '@/assets/icons/order/icon-finish.png'
import groupApi from '@/api/activity'
import { Loading } from 'element-ui'
import QRCode from 'qrcodejs2'
import getData from '@/api/details'
import { getStorage } from '@/lib/utils.js'
export default {
  components: {},
  data() {
    return {
      isBuy: false,
      favorablePrice: 0,
      groupCode: '',
      orderId: '',
      activityStatus: 0,
      saleAttributes: [],
      joinNum: 0,
      progressList: [{}, {}],
      addressShow: false,
      orderAddress: {},
      isAfter: false,
      activityTag: {
        2: '搭配购',
        3: '抽奖类',
        5: '限时抢购',
        6: '团购',
        8: '集客',
        9: '主题',
        10: '投票',
        11: '裂变',
        14: '签到集卡',
        16: '邀请下单',
        18: '预售',
        19: '神券',
        20: '拍卖',
        21: '买赠'
      },
      isReceiving: false,
      showConfirm: false,
      dateFormate,
      type: 0,
      statusText: ['待付款', '待收货', '待发货', '交易关闭', '已支付', '已退款', '已完成', '已取消', '已失效'],
      statusIcon: [
        iconToPay,
        iconToPay,
        iconToPay,
        iconClose,
        iconFinish,
        iconFinish,
        iconFinish,
        iconClose,
        iconClose
      ],
      reasonId: '', // 取消订单获取理由id
      detail: {},
      invoice: null,
      dealer: null,
      showCancelBox: false,
      cancelId: '',
      showOrderDelivery: false,
      orderDiscounts: [],
      activityDiscounts: 0,
      pointDiscounts: 0,
      couponDiscounts: 0,
      orderInfo: {}, // 订单信息
      progress: [
        {
          title: '提交订单',
          time: ''
        },
        {
          title: '付款成功',
          time: ''
        },
        {
          title: '交易完成',
          time: ''
        }
      ],
      goods: {
        skuExtInfo: {
          // skuImage: ''
        }
      },
      loading: false,
      logisticsLoading: false, // 物流loading
      confirmLoading: false, // 确认收货loading
      acId: '',
      groupOrderId: '',
      shareId: '',
      shareInfoType: '',
      ifSuccess: false,
      acType: 0,
      isgrouping: false,
      payType: 0,
      hasGroupInfos: false,
      activityCode: '',
      crowdfundingInfo: {},
      isItemType: null,
      tagName: '拍卖',
      isFree: false,
      remark: '',
      quantity: 0,
      status: 0,
      showQRcode: false,
      smallGroupTitle: ''
    }
  },
  computed: {
    parentId() {
      // 父订单id
      return this.orderInfo && this.orderInfo.parentId ? this.orderInfo.parentId : this.orderInfo.id
    },
    createdAt() {
      return this.detail.orderDetailDtos && this.detail.orderDetailDtos[0].orderInfo.createdAt
    },
    activeIndex() {
      // 订单进度
      return this.type === 2 ? 1 : this.type === 1 ? 2 : 4
    }
  },
  created() {
    this.init()
  },
  mounted() {
    this.$nextTick(function() {
      // this.bindQRCode()
    })
  },
  methods: {
    bindQRCode() {
      const dealercardwebUrl = getStorage('domain', 'localStorage').h5mallUrl
      const url = dealercardwebUrl + '/pages/activity/smallGroupDetail?recordId=' + this.$route.query.recordId
      let code = null
      this.$nextTick(function() {
        code = new QRCode(this.$refs.qrCodeDiv, {
          text: url,
          width: 220,
          height: 220,
          colorDark: '#000000', // 二维码颜色
          colorLight: '#ffffff', // 二维码背景色
          correctLevel: QRCode.CorrectLevel.L // 容错率，L/M/H
        })
      })
      return code
    },
    /**
     * @descripttion: 崔源
     * @Author: cuiyuan
     * @Date: 2021-01-22 16:59:21
     * @param {void}
     * @return {void}
     */
    logisticsShow() {
      this.logisticsDialog = false
    },
    confirmShow() {
      this.showConfirm = false
    },

    loadingInstance(options) {
      return Loading.service(options)
    },
    shareDetail() {
      groupApi.shareDetail({ recordId: this.$route.query.recordId }).then((res) => {
        this.groupCode = res.data.shareGroupJoinRecordDto[0].groupCode
        if (res.data.shareFissionDto) {
          this.showQRcode = true
          this.$nextTick(function() {
            this.bindQRCode()
          })
          if (res.data.shareFissionDto.equityDto && res.data.shareFissionDto.equityDto.equityName) {
            this.smallGroupTitle = res.data.shareFissionDto.equityDto.equityName
          }
          this.smallGroupNum = res.data.shareFissionDto.quantity - res.data.shareGroupJoinRecordDto.length
        }
      })
    },
    /* 去支付 */
    toPay(status) {
      if (status === 0) {
        if (this.activityStatus === 1 && !this.isBuy) {
          this.$feedback('活动未结束')
        } else {
          const data = {
            vmId: 1,
            terminal: 1,
            orderChannel: 0,
            gpRecordId: Number(this.$route.query.recordId),
            groupCode: this.groupCode,
            itemToOrderList: [
              {
                skuId: this.goods.skuId,
                quantity: this.goods.skuNum || 1,
                itemId: this.goods.itemId,
                activityId: this.$route.query.activityId
              }
            ]
          }
          this.loadingInstance({ fullscreen: true })
          getData.goBuy(data).then(
            (res) => {
              const { data, status, message } = res
              this.loadingInstance().close()
              if (status === 200) {
                this.$router.push({
                  name: 'order-confirm',
                  params: { orderId: data }
                })
              } else if (status === 400) {
                this.loadingInstance().close()
                this.$feedback(message)
              }
            },
            (res) => {
              if (res.message === 'Request failed with status code 401') {
                this.loadingInstance().close()
              } else {
                this.$feedback(res.message)
                this.loadingInstance().close()
              }
            }
          )
        }
      } else {
        this.$router.push(`/personCenter/orderDetail?id=${this.orderId}`)
      }
    },
    /* 参团进度 */
    getLadders() {
      let params = {
        activityId: this.$route.query.activityId
      }
      groupApi.ladders(params).then((res) => {
        this.joinNum = res.data.joinNum
        this.hintNum = res.data.hintNum
        this.favorablePrice = res.data.price
        this.progressList = res.data.ladder
        if (this.joinNum > this.progressList[this.progressList.length - 1].participantNum) {
          this.isBuy = true
        }
      })
    },
    // 改变进度条的颜色
    customColorMethod(percentage) {
      if (percentage <= 50) {
        return '#F7442A'
      } else {
        return '#C6001F'
      }
    },
    // 计算进度条的百分比
    groupRate(item) {
      // 只有一个阶梯的时候
      if (item.length === 1) {
        let current = this.joinNum
        let all = item[item.length - 1].participantNum
        if (!current || !all) {
          return 0
        }
        if (current >= all) {
          return 100
        } else if (current <= 0) {
          return 0
        } else {
          return parseInt((current / all) * 100)
        }
      } else if (item.length === 2) {
        // 第一阶梯
        if (this.joinNum < item[0].participantNum) {
          let current = this.joinNum
          let all = item[0].participantNum
          if (!current || !all) {
            return 0
          }
          if (current >= all) {
            return 100 * 0.5
          } else if (current <= 0) {
            return 0
          } else {
            return parseInt((current / all) * 100 * 0.5)
          }
        } else {
          // 第二阶梯
          let current = this.joinNum - item[0].participantNum
          let all = item[1].participantNum - item[0].participantNum
          if (!current || !all) {
            return 0 + 50
          }
          if (current >= all) {
            return 100
          } else if (current <= 0) {
            return 0 + 50
          } else {
            return parseInt((current / all) * 100 * 0.5 + 50)
          }
        }
      }
    },
    percentage(item) {
      if (item.ladderNo < this.hintNum) {
        return 100
      } else if (item.ladderNo === this.hintNum) {
        if (item.participantNum > this.joinNum) {
          return item.participantNum ? ((item.participantNum - this.joinNum) / item.participantNum) * 100 : 0
        } else {
          return 100
        }
      } else {
        return 0
      }
    },
    needNum(item) {
      if (item.ladderNo < this.hintNum) {
        return 0
      } else if (item.ladderNo === this.hintNum) {
        return item.participantNum
          ? item.participantNum - this.joinNum > 0
            ? item.participantNum - this.joinNum
            : 0
          : 0
      } else {
        return item.participantNum ? item.participantNum : 0
      }
    },
    /* 初始化页面 */
    init() {
      this.getDetail()
      this.getLadders()
      this.shareDetail()
    },
    getDetail() {
      let userInfo = getStorage('userInfo')
      let params = {
        recordId: this.$route.query.recordId,
        userId: userInfo.id
      }
      groupApi.recordItem(params).then((res) => {
        this.goods = res.data
        if (this.goods && this.goods.skuExtInfo) {
          this.status = this.goods.status
          this.activityStatus = this.goods.activityStatus
          this.orderId = this.goods.mallOrderId
          this.$emit('getItemName', this.goods.itemName)
          this.goods.skuExtInfo = JSON.parse(this.goods.skuExtInfo)
          if (this.goods.skuExtInfo.saleAttributes) {
            this.saleAttributes = JSON.parse(this.goods.skuExtInfo.saleAttributes)
          }
        }
      })
    },
    toCouponRed() {
      this.$router.push({ name: 'redEnvelopes' })
    },
    // 状态转换
    transType(status) {
      const stateTrans = {
        0: 0, // 待付款
        3: 1, // 待收货
        2: 2, // 待发货
        '-80': 3, // 交易关闭
        1: 4, // 已支付
        '-2': 5, // 已退款
        88: 6, // 已完成
        '-5': 7, // 已取消
        '-4': 8 // 已失效
      }
      return stateTrans[status]
    },
    timeEnd() {
      if (this.detail.payOutTime) this.type = 4
    },
    // 跳支付
    pay() {
      this.$router.push(`/order/payConfirm/${this.parentId}`)
    },
    /**
     * @descripttion: 崔源
     * @Author: cuiyuan
     * @Date: 2021-01-21 23:36:50
     * @param {obj} item [商品信息]
     * @return {void}
     */
    jumpAfter(item) {
      this.$router.push(
        `/personCenter/rejectSubmit?orderId=${item.orderId}&orderContractId=${item.orderContractId}&proId=${item.id}&itemType=${item.itemType}`
      )
    },
    // 跳转到申请退货
    toRefund(goods) {}
  }
}
</script>

<style scoped lang="scss">
@mixin icon($size, $mr) {
  display: inline-block;
  height: $size;
  width: $size;
  background-size: $size $size;
  margin-right: $mr;
}
.underline {
  text-decoration: underline;
  text-align: center;
  margin-top: 5px;
  cursor: pointer;
}
.lottery-tips {
  color: #c6001f;
}
.warning-icon {
  display: inline-block;
  width: 16px;
  height: 16px;
  background: url('../../assets/icons/order/warring-icon.png') no-repeat;
  background-size: 100% 100%;
  margin: 3px 3px 0 3px;
}
.btn {
  width: 133px;
  height: 40px;
  color: #fff;
  font-size: 18px;
  line-height: 40px;
  background: #c6001f;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s;
  &.pay {
    &:hover {
      background: #ee4039;
    }
  }
  &.black {
    background: #333;
    color: #fff;
    &:hover {
      background: #444;
    }
  }
  &.blank {
    color: #333;
    border: 1px solid #333;
    background-color: #fff;
    &:hover {
      opacity: 1;
      background-color: #333;
      color: #fff;
    }
  }
}
.invoice-info {
  display: flex;
  justify-content: space-between;
  .btn-box {
    display: flex;
    align-items: flex-end;
  }
}
.order-message {
  display: flex;
  justify-content: space-between;
  .payment-amount {
    margin-top: 102px;
    margin-right: 60px;
    display: flex;
    .left {
      width: 98px;
      height: 33px;
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #252525;
      line-height: 33px;
      margin-right: 24px;
    }
    .right {
      height: 33px;
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #c6001f;
      line-height: 33px;
    }
  }
}
.flex {
  display: flex;
}
.flex-center {
  display: flex;
  align-items: center;
  justify-content: left;
  .left {
    width: 84px;
    height: 24px;
    font-size: 16px;
    font-family: SourceHanSansSC-Regular, SourceHanSansSC;
    font-weight: 400;
    color: #a2a2a2;
    line-height: 24px;
    // letter-spacing: 5px;
    text-align: justify;
    margin-right: 35px;
    .empty {
      display: inline-block;
      width: 100%;
    }
  }
}
.js-center {
  justify-content: center;
}
.flex-grow {
  flex-grow: 1;
}
.border-b {
  border-bottom: 1px solid #d4d4d4;
}
.border-l {
  border-left: 1px solid #d4d4d4;
}
.color-666 {
  color: #666;
}
.color-777 {
  color: #777;
}
.text-align-l {
  text-align: left;
}
.font-size18 {
  font-size: 18px;
}
.color-red {
  color: #c6001f;
}
.margin-left14 {
  margin-left: 14px;
}
.margin-left5 {
  margin-left: 8px;
}

.order-detail {
  display: flex;
  text-align: left;
  /*background: #f9f9f9;*/
  // width: 1380px;
  color: #333;
  overflow: hidden;
  margin-bottom: 50px;
  & > header {
    box-sizing: border-box;
    padding: 29px 34px 21px 25px;
    width: 100%;
    color: #333;
    border-top: 4px solid #c6001f;
    font-size: 14px;
    background: #fff;
    margin-bottom: 10px;
    .color-777 {
      line-height: 30px;
      height: 30px;
      .mz-message {
        display: inline-block;
        margin-left: 14px;
        img {
          width: 16px;
          height: 16px;
          float: left;
          margin-top: 7px;
          margin-right: 3px;
        }
      }
    }
    .icon-to-pay {
      @include icon(34px, 12px);
      margin: 17px 12px 19px 0;
    }
    .operation {
      width: 133px;
      text-align: center;
      a {
        color: #666;
        text-decoration: underline;
        cursor: pointer;
        &:hover {
          color: #333;
        }
      }
    }
    .count-down {
      color: #ff0035;
      margin-left: 5px;
    }
    .express-id {
      color: #ff6701;
      margin-left: 8px;
    }
  }
  .order-detail-left {
    flex: 1;
  }
  .order-detail-right {
    flex: 1;
    // width: 387px;
    .price-box {
      margin-left: 37px;
      width: 350px;
      // height: 349px;
      background: #fff;
      margin-bottom: 50px;
      .box-title {
        padding-top: 23px;
        font-size: 20px;
        font-family: SourceHanSansSC-Normal, SourceHanSansSC;
        font-weight: 400;
        color: #252525;
        display: flex;
        flex-direction: column;
        align-items: center;
        .left {
          width: 80px;
          height: 29px;
          font-size: 20px;
          font-family: SourceHanSansSC-Normal, SourceHanSansSC;
          font-weight: 400;
          color: #252525;
          line-height: 29px;
        }
        .right {
          margin-top: 4px;
          margin-bottom: 13px;
          // height: 29px;
          font-size: 20px;
          font-family: SourceHanSansSC-Normal, SourceHanSansSC;
          font-weight: 400;
          color: #252525;
          line-height: 29px;
          text-align: center;
          .smallGroupTitle {
            color: #c6001f;
            text-decoration: underline;
            cursor: pointer;
          }
        }
        .coupon {
          color: #c6001f;
          text-decoration: underline;
        }
      }
      .bottom {
        display: flex;
        justify-content: center;
        .qrCode-wrap {
          // margin-top: 20px;
          width: 220px;
          height: 243px;
          .text {
            text-align: center;
            height: 23px;
            line-height: 23px;
          }
        }
      }
      li {
        font-size: 18px;
        margin-top: 16px;
        &:last-child {
          font-weight: 500;
        }
        span {
          font-weight: 500;
        }
      }
    }
  }
}

main {
  text-align: center;
  background: #fff;
  margin-bottom: 10px;
  .header {
    padding: 20px 62px 15px 31px;
    display: flex;
    justify-content: space-between;
    font-size: 16px;
    @extend .border-b;
    .title {
      width: 89px;
      height: 33px;
      font-size: 22px;
      font-family: SourceHanSansSC-Regular, SourceHanSansSC;
      font-weight: 400;
      color: #252525;
      line-height: 33px;
    }
    .num {
      width: 28px;
      height: 38px;
      font-size: 26px;
      font-family: SourceHanSansSC-Regular, SourceHanSansSC;
      font-weight: 400;
      color: #c6001f;
      line-height: 38px;
    }
  }
  .order-container {
    padding: 22px 0 12px 25px;
    .col {
      padding-top: 60px;
      font-size: 18px;
    }
    .after {
      color: #0000ff;
      cursor: pointer;
    }
    .activityTag {
      padding: 0 3px;
      color: #fff;
      background: #df3d36;
      font-weight: 400;
      height: 21px;
      font-size: 16px;
      font-family: PingFangSC;
      font-weight: 500;
      line-height: 21px;
      margin-right: 5px;
      min-width: 80px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .goods-name {
      overflow: hidden;
      word-break: keep-all;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .prizeTab {
      padding: 0 3px;
      height: 21px;
      margin-right: 5px;
    }
  }
}
.activity-schedule {
  margin-top: 6px;
  background: #fff;
  height: 225px;
  display: flex;
  flex-direction: column;
  padding: 0 41px;
  .header {
    margin: 17px 0;
    width: 88px;
    height: 33px;
    font-size: 22px;
    font-family: SourceHanSansSC-Regular, SourceHanSansSC;
    font-weight: 400;
    color: #252525;
    line-height: 33px;
  }
  .activity-message {
    .activity-status {
      width: 120px;
      height: 33px;
      font-size: 24px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 33px;
      margin-right: 29px;
    }
    .activity-num {
      height: 33px;
      font-size: 24px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 33px;
    }
    .activity-progress {
      display: flex;
      .progress-bar {
        width: 100%;
        height: 108px;
        box-sizing: border-box;
        margin-top: 10px;
        .progress-text {
          width: 75px;
        }
        .progress-text-begin {
          width: 75px;
          color: #252525;
        }
        .progress-text:nth-of-type(2) {
          text-align: center;
        }
        .progress-text:last-of-type {
          text-align: right;
        }
        .progress-top {
          font-size: 16px;
          color: #d20c33;
          display: flex;
          justify-content: space-between;
          line-height: 24px;
        }
        .progress-center {
          margin: 7px 0px;
          position: relative;
          width: 100%;
          height: auto;
          .white-line {
            width: 4px;
            height: 12px;
            position: absolute;
            background-color: #fff;
            left: 50%;
            top: 50%;
            margin: -6px 0 0 -2px;
          }
        }
        .progress-bottom {
          display: flex;
          justify-content: space-between;
          font-size: 16px;
          color: #6c6c6c;
          line-height: 24px;
        }
      }
      .progress-item {
        margin-right: 5px;
        flex: 1;
        &::v-deep .el-progress-bar__inner {
          background-color: #c6001f;
          border-radius: 0;
        }
        &::v-deep .el-progress-bar__outer {
          background-color: #f4c4c9;
          border-radius: 0;
        }
        .progress {
          margin-top: 9px;
          margin-bottom: 10px;
        }
        .first {
          display: flex;
          justify-content: space-between;
        }
        .others {
          display: flex;
          justify-content: flex-end;
        }
        .tips {
          width: 95px;
          height: 22px;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #c6001f;
          line-height: 22px;
        }
        .price {
          height: 24px;
          font-size: 16px;
          font-family: SourceHanSansSC-Normal, SourceHanSansSC;
          font-weight: 400;
          color: #d20c33;
          line-height: 24px;
        }
        .short {
          width: 34px;
          height: 24px;
          font-size: 16px;
          font-family: SourceHanSansSC-Normal, SourceHanSansSC;
          font-weight: 400;
          color: #6c6c6c;
          line-height: 24px;
        }
        .num {
          height: 24px;
          font-size: 16px;
          font-family: SourceHanSansSC-Normal, SourceHanSansSC;
          font-weight: 400;
          color: #6c6c6c;
          line-height: 24px;
        }
      }
    }
  }
}
.button {
  display: flex;
  justify-content: flex-end;
  margin-top: 44px;
  .to-pay {
    width: 205px;
    height: 45px;
    background: #c6001f;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 45px;
    text-align: center;
  }
}
.state-box {
  overflow: hidden;
  padding: 26px 0 18px 0;
  background: #fff;
  color: #000;
  .flex-center {
    display: flex;
    // justify-content: space-around;
  }
  .spot-box {
    display: flex;
    justify-content: flex-end;
    width: 27%;
    &:last-child {
      display: flex;
      justify-content: flex-start;
    }
  }
  .spot {
    height: 58px;
    width: 58px;
    border-radius: 58px;
    line-height: 58px;
    text-align: center;
    font-size: 30px;
    background: #ccc;
    color: #ffffff;
    &.active {
      background: #333;
      background-image: url('../../assets/icons/order/icon-hook.png');
      background-repeat: no-repeat;
      background-position: center center;
    }
  }
  .line {
    height: 4px;
    background: #ccc;
    // width: 170px;
    width: 73%;
    &.active {
      background: #333;
    }
  }
  .icon {
    &:last-child {
      .line {
        &:last-child {
          height: 0;
        }
      }
    }
    &:first-child {
      .line {
        &:first-child {
          height: 0;
        }
      }
    }
  }
  .des-container {
    height: 58px;
    display: flex;
    justify-content: center;
    // justify-content: space-between;
    padding-left: 0px;
  }
  .description {
    // float: left;
    // overflow: hidden;
    text-align: center;
    font-size: 14px;
    color: #777;
    // width: 228px;
    // margin-right: 170px;
    p {
      line-height: 20px;
    }
    .title {
      margin: 16px 0 2px 0;
      &.active {
        color: #333;
      }
    }
    &:first-child {
      margin-left: 0px;
    }
    &:last-child {
      // width: 165px;
      margin-right: 0;
    }
  }
}
section {
  background: #fff;
  padding: 25px 25px 30px;
  font-size: 16px;
  margin-bottom: 10px;
  li {
    font-size: 16px;
    padding-left: 10px;
    list-style-type: none;
    margin-top: 10px;
    &:first-child {
      margin-top: 12px;
    }
  }
  header {
    @extend .font-size18;
    font-weight: 500;
  }
}
.order {
  margin-bottom: 10px;
}
.goods {
  margin-bottom: 10px;
  .img-con {
    width: 166px;
    height: 144px;
    background-size: contain;
    background-repeat: no-repeat;
    cursor: pointer;
  }
  .goods-inf {
    padding: 0px 15px;
    p {
      font-size: 16px;
      // margin-top: 8px;
      line-height: 22px;
      max-width: 230px;
    }
    .title {
      @extend .font-size18;
      display: flex;
      // align-items: flex-end;
      align-items: center;
      font-weight: 500;
      .groupTag {
        position: relative;
        top: 5px;
      }
      .crowdTag {
        position: relative;
        top: 7px;
      }
    }
    .goods-sku {
      text-align: left;
      margin-top: 38px;
      height: 22px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #a2a2a2;
      line-height: 22px;
    }
  }
  .price {
    color: #c6001f;
    font-size: 18px;
  }
}
.qrcodeBox {
  float: left;
  width: 248px;
  height: 269px;
  text-align: center;
  background: #fff;
  border: 1px solid #c6001f;
  .redBox {
    font-size: 18px;
    font-family: MicrosoftYaHei;
    color: #333;
    margin: 25px 0 15px 0;
    span {
      color: #c6001f;
    }
    .joinText {
      cursor: pointer;
      color: #c6001f;
      text-decoration: underline;
    }
  }
  .groupSuccess {
    margin-top: 15px;
  }
  .codeBox {
    margin-left: 45px;
    span {
      text-align: center;
      color: #999;
      display: block;
      font-size: 20px;
      margin: 20px 0 10px 0;
      font-size: 18px;
    }
  }
  .shareText {
    color: #999;
    margin: 15px 0 15px 0;
    font-size: 18px;
  }
}
.crowdQrcodeBox {
  float: left;
  width: 248px;
  height: 269px;
  text-align: center;
  background: #fff;
  border: 1px solid #c6001f;
  .crowdBox {
    margin: 30px 45px 11px;
    span {
      text-align: center;
      color: #999;
      display: block;
      font-size: 20px;
      margin: 20px 0 10px 0;
      font-size: 18px;
    }
  }
  .gearText {
    width: 160px;
    text-align: center;
    color: #999;
    margin: 15px auto 15px;
    font-size: 16px;
    line-height: 22px;
    height: 22px;
    span {
      color: #c6001f;
    }
  }
}

// .price-box {
//   padding-left: 30px;
//   height: 303px;
//   background: #fff;
//   margin-bottom: 50px;
//   .box-title {
//     margin-top: 26px;
//     padding-top: 11px;
//     height: 33px;
//     font-size: 22px;
//     font-family: SourceHanSansSC-Regular, SourceHanSansSC;
//     font-weight: 400;
//     color: #252525;
//     line-height: 33px;
//     .coupon {
//       color: #c6001f;
//       text-decoration: underline;
//     }
//   }
//   .bottom {
//     display: flex;
//     justify-content: space-between;
//     .qrCode-wrap {
//       margin-top: 20px;
//       width: 189px;
//       height: 212px;
//       .text {
//         text-align: center;
//         height: 23px;
//         line-height: 23px;
//       }
//     }
//   }
//   .price-detail {
//     color: #333333;
//     font-size: 18px;
//     padding: 20px 0px;
//     border-bottom: 1px solid #d0d0d0;
//     font-weight: bold;
//   }
//   .price-inf {
//     .all-price {
//       padding-top: 37px;
//       font-weight: bold;
//       font-size: 23px;
//     }
//   }
//   li {
//     font-size: 18px;
//     margin-top: 16px;
//     &:last-child {
//       font-weight: 500;
//     }
//     span {
//       font-weight: 500;
//     }
//   }
//   .color-999 {
//     color: #999;
//   }
//   .color-pink {
//     height: 24px;
//     font-size: 16px;
//     font-family: SourceHanSansSC-Regular, SourceHanSansSC;
//     font-weight: 400;
//     color: #c6001f;
//     line-height: 24px;
//   }
//   .total-pay {
//     font-size: 24px;
//     // text-indent: 5px;
//     // letter-spacing: 0;
//   }
// }
.fw-600 {
  font-weight: 600;
}
.auctionTag {
  display: inline-block;
  // width: 30px;
  padding: 0 3px;
  height: 19px;
  color: #fff;
  font-family: NotoSansHans-Regular;
  font-weight: 400;
  font-size: 12px;
  text-align: center;
  line-height: 18px;
  background: #c6001f;
  margin-right: 3px;
  padding: 0 2px;
}
// 物流弹窗
.logistic-box {
  .flex-start-box {
    display: flex;
    align-items: flex-start;
    text-align: left;
    // .flex-start {
    //   display: flex;
    //   align-items: flex-start;
    //   justify-content: center;
    //   text-align: left;
    .goods-inf {
      position: relative;
      p {
        position: absolute;
        width: 100%;
        line-height: 28px;
        height: 28px;
        color: #fff;
        text-align: center;
        font-size: 14px;
        bottom: 0;
        background: rgba(37, 37, 37, 0.8);
      }
      img {
        width: 162px;
        height: 114px;
      }
    }
    .express-box {
      height: 114px;
      display: flex;
      width: 100%;
      justify-content: space-between;
      align-items: center;
      .express {
        padding: 3px 25px;
        font-size: 15px;
        color: #333;
        .margin-top5 {
          margin-top: 15px;
        }
        .fw-500 {
          font-weight: 500;
        }
      }
    }
    // }
  }
}
</style>
